module.exports = __webpack_public_path__ + "static/img/white_l_logo.c37b5950.png";